<template>
    <b-form-group
        label="Roles"
        :label-cols="labelCols"
        v-slot="{ ariaDescribedby }"
        :label-class="labelClass"
    >
        <b-form-radio-group
            v-model="selectedRole"
            :options="allRoles"
            :aria-describedby="ariaDescribedby"
            name="radios-stacked"
            text-field="name"
            value-field="id"
            :stacked="stacked"
        ></b-form-radio-group>
    </b-form-group>
</template>
<script>
export default {
    data() {
        return {
            selectedRole: null,
        }
    },
    props: ['allRoles', 'value', 'stacked', 'labelCols', 'labelClass'],
    watch: {
        selectedRole: function (id) {
            const item = this.allRoles.find(x => x.id == id) || {}
            console.log('item', item)
            this.$emit('input', [item.name])
        },
        value: function (value) {
            this.processValue(value)
        },
    },

    mounted() {
        this.processValue(this.value)
    },
    methods: {
        processValue(value) {
            console.log('value', value)
            const role_name = value ? value[0] : null
            const selectedRole = this.allRoles.find(x => x.name == role_name)
            this.selectedRole = selectedRole ? selectedRole.id : null
            console.log(' this.selectedRole', this.selectedRole)
        },
    },
}
</script>